import React, { Component, Fragment } from 'react';
import axios from 'axios';

import { currentUser } from '../../services/userURLs';

export default class RenderLogin extends Component {
  state = { isLoggedIn: false };

  componentDidMount = () => {
    axios.get(currentUser, {
      withCredentials: true
    })
    .then(res => {
      if (res.data) {
        this.setState({ isLoggedIn: !this.state.isLoggedIn });
      } 
    })
    .catch(err => {
      console.log(err.message);
    })

  };

  render() {
    console.log("this.state render login", this.state);

    if (this.state.isLoggedIn) {
      return null;
    } else {
      return <Fragment>{this.props.children}</Fragment>;
    }
  }
}
